import { render, staticRenderFns } from "./CallToActionItem.vue?vue&type=template&id=35e93f19&"
import script from "./CallToActionItem.vue?vue&type=script&lang=js&"
export * from "./CallToActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,OpusLink: require('/~/src/modules/opus/components/Link.vue').default})
